/* eslint-disable max-classes-per-file */
import { Injectable } from "@angular/core";
import {
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbDateStruct,
    NgbTimeAdapter,
    NgbTimeStruct,
} from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class CustomDateAdapter extends NgbDateAdapter<number> {
    fromModel(value: number | null): NgbDateStruct | null {
        if (value) {
            const date = new Date(value);
            return {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate(),
            };
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): number | null {
        if (date) {
            const jsDate = new Date(date.year, date.month - 1, date.day);
            return jsDate.getTime();
        }
        return null;
    }
}

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    readonly DELIMITER = "/";

    parse(value: string): NgbDateStruct | null {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: Number.parseInt(date[0], 10),
                month: Number.parseInt(date[1], 10),
                year: Number.parseInt(date[2], 10),
            };
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date
            ? date.day +
                  this.DELIMITER +
                  date.month +
                  this.DELIMITER +
                  date.year
            : "";
    }
}

// ---------- Time Adapters
@Injectable()
export class CustomTimeAdapter extends NgbTimeAdapter<number> {
    fromModel(value: number | null): NgbTimeStruct | null {
        if (value) {
            const date = new Date(value);
            return {
                hour: date.getUTCHours(),
                minute: date.getMinutes(),
                second: date.getSeconds(),
            };
        }
        return null;
    }

    toModel(time: NgbTimeStruct | null): number | null {
        if (time) {
            return (time.hour * 60 + time.minute) * 60000;
        }
        return null;
    }
}
